import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Login from "../components/Login";

export default withRouter(connect()(Login));
